<template>
    <div class="sc-search">
        <el-input ref="inputRef" v-model="inputKey" placeholder="搜索" size="large" clearable prefix-icon="el-icon-search" :trigger-on-focus="false" @input="inputChange"/>
        <div class="sc-search-history" v-if="history.length>0">
            <el-tag closable effect="dark" type="info" v-for="(item, index) in history" :key="item" @click="historyClick(item)" @close="historyClose(index)">{{item}}</el-tag>
        </div>
        <div class="sc-search-result">
            <div class="sc-search-no-result" v-if="result.length<=0">暂无搜索结果</div>
            <ul v-else>
                <el-scrollbar max-height="366px">
                    <li v-for="item in result" :key="item.path" @click="toUrl(item)">
                        <el-icon><component :is="item.icon || 'el-icon-menu'" /></el-icon>
                        <span class="title">{{ item.breadcrumb }}</span>
                    </li>
                </el-scrollbar>
            </ul>
        </div>
    </div>
</template>

<script>
    import { getCurrentInstance, defineComponent, ref, watch, computed } from 'vue'
    import { useNavlistStore } from '@/store'
    import Cache from '@/utils/cache'

    export default defineComponent({
        setup(props, context) {
            const StoreNavlist = useNavlistStore()
            const { proxy } = getCurrentInstance()
            const inputRef = ref()
            const inputKey = ref('')
            const menu = ref([])
            const result = ref([])
            const history = ref([])
            history.value = Cache.get('SEARCH_HISTORY') || []
            const menuTree = computed(() => StoreNavlist.list)
            const inputChange = (value) => {
                if (value) {
                    result.value = menuFilter(value)
                } else {
                    result.value = []
                }
            }
            const filterMenu = (map) => {
                map.forEach(item => {
                    if (item.meta.hidden || item.meta.type === 'button') {
                        return false
                    }
                    if (item.meta.type === 'iframe') {
                        item.path = `/i/${item.name}`
                    }
                    if (item.children && item.children.length > 0) {
                        filterMenu(item.children)
                    } else {
                        menu.value.push(item)
                    }
                })
            }
            const menuFilter = (queryString) => {
                var res = []
                // 过滤菜单树
                var filterMenu = menu.value.filter((item) => {
                    if ((item.meta.title).toLowerCase().indexOf(queryString.toLowerCase()) >= 0) {
                        return true
                    }
                })
                // 匹配系统路由
                var router = proxy.$router.getRoutes()
                var filterRouter = filterMenu.map((m) => {
                    if (m.meta.type === 'link') {
                        return router.find(r => r.path === '/' + m.path)
                    } else {
                        return router.find(r => r.path === m.path)
                    }
                })
                // 重组对象
                filterRouter.forEach(item => {
                    res.push({
                        name: item.name,
                        type: item.meta.type,
                        path: item.meta.type === 'link' ? item.path.slice(1) : item.path,
                        icon: item.meta.icon,
                        title: item.meta.title,
                        breadcrumb: item.meta.breadcrumb.map(v => v.meta.title).join(' - ')
                    })
                })
                return res
            }
            const toUrl = (item) => {
                if (!history.value.includes(inputKey.value)) {
                    history.value.push(inputKey.value)
                    Cache.add('SEARCH_HISTORY', history.value)
                }
                if (item.type === 'link') {
                    setTimeout(() => {
                        let a = document.createElement('a')
                        a.style = 'display: none'
                        a.target = '_blank'
                        a.href = item.path
                        document.body.appendChild(a)
                        a.click()
                        document.body.removeChild(a)
                    }, 10)
                } else {
                    proxy.$router.push({ path: item.path })
                }
            }
            const historyClick = (text) => {
                inputKey.value = text
                inputChange(text)
            }
            const historyClose = (index) => {
                history.value.splice(index, 1)
                if (history.value.length <= 0) {
                    Cache.del('SEARCH_HISTORY')
                } else {
                    Cache.add('SEARCH_HISTORY', history.value)
                }
            }

            filterMenu(menuTree)
            return {
                inputRef,
                inputKey,
                result,
                history,

                inputChange,
                historyClick,
                historyClose,
                toUrl
            }
        }
    })
</script>

<style scoped>
    .sc-search {}
    .sc-search-no-result {text-align: center;margin: 40px 0;color: #999;}
    .sc-search-history {margin-top: 10px;}
    .sc-search-history .el-tag {cursor: pointer;}
    .sc-search-result {margin-top: 15px;}
    .sc-search-result li {height:56px;padding:0 15px;background: var(--el-bg-color-overlay);border: 1px solid var(--el-border-color-light);list-style:none;border-radius: 4px;margin-bottom: 5px;font-size: 14px;display: flex;align-items: center;cursor: pointer;}
    .sc-search-result li  i {font-size: 20px;margin-right: 15px;}
    .sc-search-result li:hover {background: var(--el-color-primary);color: #fff;border-color: var(--el-color-primary);}
</style>
